import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchLike as fetch } from '../api/baseQueryWithReauth.js';

export interface NotificationState {
	email: null | 'unsubscribing' | 'unsubscribed' | 'error';
	errorMessage?: string;
}

export const emailUnsubscribe = createAsyncThunk(
	'notification/unsubscribe',
	async ({ token }: { token: string }): Promise<{ token: string }> => {
		const response = await fetch('/api/users/unsubscribe', {
			method: 'GET',
			cache: 'no-cache',
			headers: {
				'Email-Unsubscribe-Token': token
			}
		});
		if (response.status === 200) {
			return await response.json();
		} else {
			const error = await response.json();
			throw new Error(error);
		}
	}
);

export const notificationSlice = createSlice({
	name: 'notification',
	initialState: {
		email: null
	} as NotificationState,
	reducers: {
		setEmail: (state, { payload }: { payload: NotificationState['email'] }) => {
			state.email = payload;
		},
		setErrorMessage: (state, { payload }: { payload: NotificationState['errorMessage'] }) => {
			state.errorMessage = payload;
		}
	},
	extraReducers: builder => {
		builder.addCase(emailUnsubscribe.fulfilled, (state, action) => {
			state.email = 'unsubscribed';
		});
		builder.addCase(emailUnsubscribe.rejected, (state, action) => {
			state.email = 'error';
			state.errorMessage = action.error.message;
		});
		builder.addCase(emailUnsubscribe.pending, (state, action) => {
			state.email = 'unsubscribing';
			state.errorMessage = undefined;
		});
	}
});

export const { setEmail } = notificationSlice.actions;
export default notificationSlice.reducer;
